import React from "react";

const HERO_IMG = `${process.env.PUBLIC_URL}/images/hero.jpg`;

export const Hero = () => {
  const scrollToProjects = (e) => {
    e.preventDefault();
    document.querySelector("#projects")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative w-full h-[100svh] min-h-[620px] overflow-hidden"
    >
      {/* Ken-burns container */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={HERO_IMG}
          alt="Strain-Brehaut Farm, Guernsey Cove, Prince Edward Island"
          className="absolute inset-0 w-full h-full object-cover sb-kenburns"
          fetchpriority="high"
        />
      </div>

      {/* Editorial dark scrim */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(26,35,48,0.55) 0%, rgba(26,35,48,0.18) 38%, rgba(26,35,48,0.78) 100%)",
        }}
      />
      {/* Thin sand horizon line at bottom of hero */}
      <div
        className="absolute left-0 right-0 bottom-0 h-[1px]"
        style={{ backgroundColor: "rgba(200,184,154,0.35)" }}
      />

      <div className="relative z-10 h-full container-editorial flex flex-col justify-end md:justify-center pb-28 md:pb-0">
        <div className="max-w-4xl">
          <p
            className="fade-up-1 font-body text-[11px] md:text-xs uppercase mb-7"
            style={{ color: "#c8b89a", letterSpacing: "0.36em" }}
          >
            studio Brehaut · Architecture · Est. 30+ years
          </p>
          <h1
            className="fade-up-2 font-display leading-[0.95] tracking-[-0.015em]"
            style={{
              color: "#f4f1eb",
              fontSize: "clamp(3rem, 9vw, 7.5rem)",
              fontWeight: 400,
            }}
          >
            Designing the
            <br />
            <em className="italic font-light" style={{ color: "#c8b89a" }}>
              East Coast
            </em>
            .
          </h1>
          <p
            className="fade-up-3 mt-8 md:mt-10 font-body text-base md:text-lg max-w-xl leading-[1.7]"
            style={{ color: "rgba(244,241,235,0.82)" }}
          >
            Architecture rooted in place, built to last.
          </p>

          <div className="fade-up-3 mt-10 md:mt-14 flex items-center gap-6">
            <a
              href="#projects"
              onClick={scrollToProjects}
              data-testid="hero-cta-view-work"
              className="group inline-flex items-center gap-4 font-body text-[12px] md:text-[13px] tracking-[0.22em] uppercase border-b pb-2.5 transition-all hover:gap-6"
              style={{ color: "#f4f1eb", borderColor: "rgba(244,241,235,0.8)" }}
            >
              View Our Work
              <span aria-hidden className="transition-transform group-hover:translate-x-1">→</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className="hidden md:block absolute left-1/2 bottom-10 -translate-x-1/2 z-10"
        aria-hidden="true"
      >
        <div
          className="scroll-indicator relative w-[22px] h-[36px] rounded-full border"
          style={{ borderColor: "rgba(244,241,235,0.6)" }}
        />
      </div>
    </section>
  );
};

export default Hero;
